export default __webpack_public_path__ + "static/media/bankofamerica-glyph.4b57a52c.png";